import getFhirJson from "../../functions/getFhirJsonAPI";
import { changeTermComments } from "../../slices/codeSystemTermDetail/codeSystemTermDetailSlice";

const loadCodeSystemTermDetailComments = async (apiToken, commentFois, dispatch) => {
    let comments = [];
    for (const foi of commentFois) {
        let fhirJson = await getFhirJson(foi, null, apiToken, false);
        let comment = {
            "author": fhirJson?.content?.[0]?.author?.display || fhirJson?.author?.[0]?.name ||  "Anonymous/Missing",
            "summary": fhirJson?.content?.[0]?.summary || "",
            "time": fhirJson?.meta?.lastUpdated || fhirJson?.date
        }
        comments.push(comment);
    }
    dispatch(changeTermComments(comments));
};

export default loadCodeSystemTermDetailComments;